export default __webpack_public_path__ + "static/media/male_head.04298fe3.png";